// extracted by mini-css-extract-plugin
export var euProgram = "eu-program-module--eu-program--hDX3y";
export var text = "eu-program-module--text--wqxPh";